"use client"
import React, {FC} from 'react';
import {WidgetTitleBar} from './component/widgetTitleBar';
import {FreeMode} from "swiper/modules";
import {Swiper, SwiperSlide} from 'swiper/react';
import Image from 'next/image';
import {WidgetContainerComponent} from "@/core/general/ui/widgetContainer.component";
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import ProviderContainerComponent from "@/core/widget/providerContainer.component";
import {GameLeagueModel} from "@/core/model/gamebox.model";
import {MenuBuilderWidgetModel} from "@/core/model/main.model";
import {useRouter} from "next/navigation";

interface LeagueListProps{
  leagueList:GameLeagueModel[]
  showMoreUrl:string
  widget: MenuBuilderWidgetModel
}

export const GameLeagueSwiperComponent: FC<LeagueListProps> = (props) => {
  const router = useRouter();
  function clickGameDetail(id: number,title:string) {
    router.push(`/t/league/${id}?shTitle=${title}`);
  }

  return (
    <WidgetContainerComponent className="fullWidth">
      <Column>
        <ProviderContainerComponent>
          <WidgetTitleBar widget={props.widget} hasTitle={true} />
        </ProviderContainerComponent>
        <Row
          className={`${props.widget.schema_data?.background_color ? 'py-2' : ''} relative totalCenter`}
          style={{ backgroundColor: props.widget.schema_data?.background_color ?? 'transparent' }}
        >
          {props.widget.schema_data?.side_image && props.widget.schema_data?.side_image_behavior === 'fading' ? (
            <Image
              alt={''}
              fill={true}
              src={props.widget.schema_data.side_image}
              sizes={'100%'}
              style={{ objectFit: 'fill' }}
              className={'swiperRecyclerFirstImage right-0'}
            />
          ) : null}
          <Row className="flex-nowrap overflow-scroll hideScrollBar">
            <Swiper
              slidesPerView={'auto'}
              freeMode={true}
              modules={[FreeMode]}
              style={{
                paddingRight:
                  props.widget.schema_data.side_image && props.widget.schema_data?.side_image_behavior === 'fading'
                    ? '10rem'
                    : ''
              }}
              className="mySwiper"
            >
              {props.widget.schema_data.side_image && props.widget.schema_data?.side_image_behavior === 'scrolling' ? (
                <SwiperSlide style={{ width: 'auto' }} key={0} virtualIndex={0}>
                  <Image
                    fill={true}
                    placeholder={'empty'}
                    alt={''}
                    src={props.widget.schema_data.side_image ?? ''}
                    style={{ objectFit: 'fill' }}
                    className={`swiperRecyclerFirstImage !relative`}
                  />
                </SwiperSlide>
              ) : null}
              {props.leagueList?.map((item, index) => (
                <SwiperSlide style={{ width: 'auto' }} key={index + 1} virtualIndex={index + 1}>
                    <div key={index} className="p-2 width-auto" onClick={()=>clickGameDetail(item.id??0,item.title??"")}>
                      <Column className={`w-auto center relative cursor-pointer`}>
                        <Image fill={true} style={{ backgroundColor: "#a0a0a0" }}
                                   src={item.background}
                                   className={"!relative w-full !h-42 aspect-[16/9] w-full !rounded-xl"}
                                   alt={""}/>
                      </Column>
                    </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Row>
        </Row>
      </Column>
    </WidgetContainerComponent>
  );
};

export default React.memo(GameLeagueSwiperComponent);
